import { api_v2 } from "@/api/axios.config"
import { Lecture } from "@/types/lectures"

export interface ApiResponse<T> {
  success: boolean
  message: string
  data: T
  meta: PaginationMeta
}

export interface PaginationMeta {
  total: number
  page: number
  limit: number
  hasMore?: boolean
  totalPages?: number
}

export type LecturesResponse = ApiResponse<Lecture[]>

export const getLectures = async (params?: {
  page?: number
  limit?: number
  search?: string
  categoria?: string
}) => {
  return api_v2.get<LecturesResponse>("/plataforma/palestras", { params })
}

export const createLecture = async (data: Omit<Lecture, "id">) => {
  return api_v2.post("/plataforma/palestras", data)
}

export const updateLecture = async (id: string, data: Partial<Omit<Lecture, "id">>) => {
  return api_v2.put(`/plataforma/palestras/`, { id, ...data })
}

export const deleteLecture = async (id: string) => {
  return api_v2.delete(`/plataforma/palestras/${id}`)
}

export const getCategories = async () => {
  return api_v2.get("/plataforma/palestras/categorias")
}
